import styled from "styled-components";

const themeTypes = {
  warning: {
    backgroundColor: "#FDF0E6",
    iconColor: "#ED6C02",
    color: "#5F2B01",
  },
};

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  background-color: ${({type}) => (themeTypes[type].backgroundColor)};
  align-items: center;

  i {
    font-size: 20px;
    padding: 0 8px;
    color:  ${({type}) => (themeTypes[type].iconColor)};
    
  }
`;

export const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.p`
  font-size: 16px;
  font-weight: 500;
  font-family: 'Work Sans';
  color: ${({type}) => (themeTypes[type].color)};
  margin: 0;
`;

export const Description = styled.p`
  font-size: 14px;
  font-family: 'Work Sans';
  color: ${({type}) => (themeTypes[type].color)};
  margin: 0;
`;
